import { render, staticRenderFns } from "./template.html?vue&type=template&id=faa5fff6&scoped=true&external"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "../style.scss?vue&type=style&index=0&id=faa5fff6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa5fff6",
  null
  
)

export default component.exports